module.exports = __webpack_public_path__ + "img/morrison-pool.d05b9d89.webp";